const types = {
  CITY_UPDATE:'CITY_UPDATE',
  LOCATION_CITY:"LOCATION_CITY",
  CITYALL_LIST:"CITYALL_LIST",
}

interface initProps {
  cityData?: any
  locationCity?: any
  cityAllList?:any
}
interface actionProps {
  cityData?: any
  locationCity?: any
  cityAllList?:any

}
const initState: initProps = {
  cityData:{
    cityId:'110100',
    cityName:'北京'
  },
  locationCity:{
    cityId:'110100',
    cityName:'北京'
  },
  cityAllList:Object

}

const cityReducer = (state = initState, action:any) => {
  const { type, cityData , locationCity , cityAllList} = action
  console.log("action===>",action)
  switch (type) {
    case types.CITY_UPDATE:
      return {
        ...state,
        cityData: cityData
      };
    case types.LOCATION_CITY:
      return {
        ...state,
        locationCity: locationCity
      };
    case types.CITYALL_LIST:
        return {
          ...state,
          cityAllList: cityAllList
        };
    default:
      return state
  }
}

export default cityReducer;

export const cityActions = {
  setCity: function (cityData: object) {
    return { type: types.CITY_UPDATE, cityData }
  },
  setLocationCity: function (locationCity: object) {
    return { type: types.LOCATION_CITY, locationCity }
  },
  setCityAllList: function (cityAllList: object) {
    return { type: types.CITYALL_LIST, cityAllList }
  },
}
